import { useState, useRef } from 'react'
import Menu from '@mui/joy/Menu'
import MenuButton from '@mui/joy/MenuButton'
import MenuItem from '@mui/joy/MenuItem'
import Dropdown from '@mui/joy/Dropdown'
import { ColorPicker } from './ColorPicker'
import Palette from '@mui/icons-material/Palette'
import PaletteOutlined from '@mui/icons-material/PaletteOutlined'

export const ColorButton = ({ onChange, currentColor }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleOpenChange = (e) => {
        // We've generally lost focus, close...
        if (e.type !== 'click') {
            setIsOpen(false)
            return
        }

        if (isOpen) {
            // user is still in the dropdown making changes, ignore the event.
            return
        }

        setIsOpen(true)
    }

    return (
        <Dropdown open={isOpen} onOpenChange={handleOpenChange}>
            <MenuButton
                sx={{ maxHeight: 40 }}
                startDecorator={
                    currentColor === '#ffffff' ? (
                        <PaletteOutlined />
                    ) : (
                        <Palette sx={{ color: currentColor }} />
                    )
                }
            >
                Color
            </MenuButton>
            <Menu>
                <MenuItem>
                    <ColorPicker
                        onChange={onChange}
                        currentColor={currentColor}
                    />
                </MenuItem>
            </Menu>
        </Dropdown>
    )
}
